export default "__VITE_ASSET__DEMwYpHn__"